import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdsIconsModule } from '@mds/icons';

export interface ForecastKpiWidget {
  icon: string;
  title: string;
  value: string;
  unit?: string;
  subtitle: string;
}

@Component({
  selector: 'app-forecast-kpi-cards',
  standalone: true,
  imports: [CommonModule, MdsIconsModule],
  templateUrl: './forecast-kpi-cards.component.html',
  styleUrls: ['./forecast-kpi-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForecastKpiCardsComponent {
  @Input() widgets: ForecastKpiWidget[] = [];
}
